const getGeneralPercentileValue = (ratings = []) =>
  ([...ratings].find((rating) => {
    const attributes = Object.keys(rating);
    return attributes.length === 1 && attributes.includes('value');
  })?.value || 0) * 100;

export default getGeneralPercentileValue;
